import { VFC, MouseEvent, useState } from 'react'
import { Menu, Typography } from '@mui/material'
import { ExpandMore, Check, ExpandLess } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import theme from 'lib/theme'
import { ReactComponent as ChangeLanguage } from 'assets/images/icon-edit-list.svg'
import {
  IconButtonWrapper,
  IconDropdownText,
} from 'components/IconDropdown/IconDropdown.styled'
import { contentLanguages } from 'lib/languages'
import { useFormikContext } from 'formik'

interface LanguageSelectorProps {
  selectedValue: string
  handleChange: (
    value: string,
    setFieldValue: (field: string, value: string) => void
  ) => void
}

export const LanguageSelector: VFC<LanguageSelectorProps> = ({
  selectedValue,
  handleChange,
}) => {
  const { setFieldValue } = useFormikContext()
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuItemClick = (
    event: MouseEvent<HTMLLIElement>,
    value: string
  ) => {
    handleChange(value, setFieldValue)
    setAnchorEl(null)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButtonWrapper
        sx={{
          width: '138px',
          backgroundColor: theme.palette.secondary.main,
          [theme.breakpoints.between('xs', 'sm')]: {
            width: '138px',
          },
        }}
        isIconOnly={false}
        isOpen={open}
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open}
        aria-haspopup='true'
        onClick={handleClick}>
        <ChangeLanguage />
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 'bold',
            fontSize: '12px',
          }}>
          {contentLanguages.find((language) => language === selectedValue)
            ? t(
                contentLanguages.find(
                  (language) => language === selectedValue
                ) || ''
              )
            : t('select')}
        </Typography>
        {anchorEl ? (
          <ExpandLess fontSize='small' />
        ) : (
          <ExpandMore fontSize='small' />
        )}
      </IconButtonWrapper>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: '138px',
            borderRadius: '1px',
          },
        }}
        sx={{ ul: { padding: 0 } }}>
        {contentLanguages.map((option) => (
          <IconDropdownText
            key={option}
            value={option}
            selected={option === selectedValue}
            onClick={(e) => handleMenuItemClick(e, option)}>
            {t(option)}
            {option === selectedValue && (
              <Check
                fontSize='small'
                sx={{ fill: theme.palette.primary.main }}
              />
            )}
          </IconDropdownText>
        ))}
      </Menu>
    </>
  )
}
